<script setup>
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import { ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
// import { isBigScreen } from '@/utils/rem';

const size = ref('default');
const route = useRoute();

// 检测是否为大屏页面
const checkBigScreen = () => {
  const isBigScreenPage = window.location.pathname.includes('/bigscreen');
  if (isBigScreenPage) {
    document.body.classList.add('bigscreen');
  } else {
    document.body.classList.remove('bigscreen');
  }
};

// 监听路由变化
watch(() => route.path, () => {
  checkBigScreen();
}, { immediate: true });

onMounted(() => {
  // 小屏幕时进行自动切换成紧凑型
  window.addEventListener('resize', () => {
    size.value = window.innerWidth < 1440 ? 'small' : 'default';
  });
  
  // 初始检查是否为大屏页面
  checkBigScreen();
});
</script>

<template>
  <el-config-provider :locale="zhCn"
                      :size="size">
    <router-view />
  </el-config-provider>
</template>
